<div class="row">
  <h3 class="col-12 card-menu">{{ 'RESERVATION.DETAIL.TITLE' | translate }}</h3>
  <h3 class="col-12 col-md-10" style="text-align: left !important">{{station?.name}}</h3>
  <h3 class="col-12 col-md-10" style="text-align: left !important">{{station?.street}} {{station?.city}}</h3>
  <!-- <label></label> -->
  <div class="col-12 col-md-10">
    <div class="col-12">
      <div class="row reservation-day  ">
        <div class="col-6 blocbook">
          <label>
            <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
            {{ 'RESERVATION.DETAIL.START' | translate }}
          </label>
        </div>
        <div class="col-6 end testbook">
          <label md-colors="{color:'primary'}">
            <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
            {{ 'RESERVATION.DETAIL.END' | translate }}
          </label>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-6 col-sm-5 blocbook">
          <label>
            {{getDateFormat(_start)}}
          </label>
        </div>
        <div class="col-sm-2 mid d-none d-sm-block">
          <mat-icon aria-hidden="false" aria-label="Example home icon">trending_flat</mat-icon>
        </div>
        <div class="col-6 col-sm-5 end testbook">
          <label>
            {{getDateFormat(_end)}}
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-2"> <img width="100%" [src]="_DomSanitizationService.bypassSecurityTrustUrl(img)"></div>
  <div></div>
  <hr>
  <div class="col-12 marge">
    <div class="row">
      <label class="col-12 col-sm-3 codemagic codemargin" style="margin: auto">{{ 'RESERVATION.DETAIL.CODE' | translate
        }}</label>
      <mat-card
        [ngClass]="{'recharge-gradien': book.type === 0 || book.type === 7,  'titleBookk': book.type === 1 || book.type === 10 || book.type === 12}"
        class="col-8 col-sm-3  mat-card codemagic codemargin">
        <h5>{{book.key}}</h5>
      </mat-card>

      <label class="col-12 col-sm-4 codemagic" style="margin: auto">{{ 'RESERVATION.DETAIL.PRICE' | translate }} :
        <strong> {{book.price}} €</strong></label>
    </div>
  </div>


  <div class="col-12 mt-3">



    <!-- <div class="row justify-content-center mb-4"> -->
      <!-- ----------------------------CARCHEKING----------------------------------------------- -->
      <!-- <button
        [ngClass]="{'recharge-gradien': book.type === 0 || book.type === 7,  'autopartage-gradien': book.type === 1 || book.type === 10}"
        *ngIf="book.actions?.add_button" class="col-8 col-md-5 mr-4" (click)="openCarChecking()" mat-raised-button>
        {{ book.actions?.add_button.label }}</button>
    </div>
    <div class="row justify-content-center"> -->
      <!-- ----------------------------COMMENCER----------------------------------------------- -->
      <!-- <button
        [ngClass]="{'recharge-gradien': book.type === 0 || book.type === 7,  'autopartage-gradien': book.type === 1 || book.type === 10}"
        *ngIf="book.actions?.start" class="col-5 col-md-3 mr-4 mb-3" (click)="openDialogInstruction()"
        mat-raised-button>{{ 'RESERVATION.DETAIL.COMMENCER' | translate }}</button> -->
      <!-- -------------------------------PROLONGER-------------------------------------------- -->
      <!-- <button
        [ngClass]="{'recharge-gradien': book.type === 0 || book.type === 7,  'autopartage-gradien': book.type === 1 || book.type === 10}"
        *ngIf="book.actions?.extend" class="col-5 col-md-3 mr-4 mb-3" (click)="openDialogExtend()" mat-raised-button>{{
        'RESERVATION.DETAIL.PROLONGER' | translate }}</button> -->
      <!-- ----------------------------------TERMINER----------------------------------------- -->
      <!-- <button *ngIf="book.actions?.stop" class="col-5 col-md-3 mr-4 mb-3" (click)="openDialogStop()" mat-raised-button
        [ngClass]="{'recharge-gradien': book.type === 0 || book.type === 7,  'autopartage-gradien': book.type === 1 || book.type === 10}">{{
        book.actions.stop.label }}</button> -->
      <!-- -----------------------------------CANCEL---------------------------------------- -->
      <!-- <button
        [ngClass]="{'recharge-gradien': book.type === 0 || book.type === 7,  'autopartage-gradien': book.type === 1 || book.type === 10}"
        *ngIf="book.actions?.cancel" class="col-5 col-md-3 mr-4" (click)="openDialogDelete()" mat-raised-button>{{
        'RESERVATION.DETAIL.CANCEL' | translate }}</button>




    </div> -->



      <!------------------------------buttons------------------------------------------------->
      <div class="row justify-content-center mb-4">

        <div *ngFor="let bloc of book.buttons" class="col-10">
  
          <div class="row justify-content-center">
  
            <h3 class="text-center mt-3" style="margin-bottom: 8px !important">{{ bloc.title }}</h3>

            <div class="col-12">

            <div class="row justify-content-center"  >
             
            <button style="color: white !important;" *ngFor="let btn of bloc.buttons" 
            class="col-12 col-sm-4 col-md-4 mx-2 my-3" (click)="actionBook(btn)"
            [style.background-color]="btn.color"  mat-raised-button > {{ btn.label }}</button>
          
            </div>

          </div>
  
            <!-- <mat-card class="col-12 mat-elevation-z9">
              <div class="card-content">
                <div *ngFor="let msg of text.messages">
                  <div class="row justify-content-center">{{msg.text}}</div>
                </div>
              </div>
            </mat-card> -->
  
          </div>
        </div>
  
      </div>



    <!------------------------------messages text------------------------------------------------->
    <div *ngIf="book.texts.length > 0" class="row justify-content-center mb-4">

      <div *ngFor="let text of book.texts" class="col-10">

        <div class="row justify-content-center">

          <h3 class="text-center mt-3" style="margin-bottom: 8px !important">{{ text.title }}</h3>

          <mat-card class="col-12 mat-elevation-z9">
            <div class="card-content">
              <div *ngFor="let msg of text.messages">
                <div class="row justify-content-center">{{msg.text}}</div>
              </div>
            </div>
          </mat-card>

        </div>
      </div>

    </div>



  </div>
</div>






















<!-- 
<mat-card class=" box-shadow ">
  <ng-template [ngIf]="station != null">
    <mat-card-header>
      <mat-card-title class="col-12">
        <h3 class="col-12 card-menu">Détail de la réservation</h3>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="col-12">

        <div class="row justify-content-center">
          <mat-toolbar class="col-8">
            <mat-toolbar-row>
              <h5 class="col-12 ">
                {{book.key}}
              </h5>
            </mat-toolbar-row>
          </mat-toolbar>
          <h4 class="col-12">
            <mat-icon aria-hidden="false" aria-label="Example home icon">place</mat-icon>
            {{_station.name}}
          </h4>
          <label class="col-12">
            Adresse : {{station.street}} {{station.city}}
          </label>
          <div class="col-12">
            <div class="row reservation-day">
              <div class="col-6">
                <label>
                  <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
                  Début de reservation
                </label>
              </div>
              <div class="col-6 end">
                <label class="">
                  <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
                  Fin de reservation
                </label>
              </div>
            </div>
          </div>
          <hr>
          <div class="col-12 marge">
            <div class="row">
              <div class="col-5">
                <label>
                  {{start | date:"dd/MM/yyyy HH:mm"}}
                </label>
              </div>
              <div class="col-2 mid">
                <mat-icon aria-hidden="false" aria-label="Example home icon">trending_flat</mat-icon>
              </div>
              <div class="col-5 end">
                <label>
                  {{end | date:"dd/MM/yyyy HH:mm"}}
                </label>
              </div>
            </div>
          </div>

          <div class="col-sm-6 ">
            <label class="row">
              <mat-icon aria-hidden="false" aria-label="Example home icon">credit_card</mat-icon>
              Prix de la réservation : {{book.price}} €
            </label>
          </div>
          <div class="col-sm-6 end">
            <label class="row" class="{{book.status}}" *ngIf="book.status == 'reserved'">
              status : réservée
            </label>
            <label class="row" class="{{book.status}}" *ngIf="book.status == 'completed'">
              status : terminée
            </label>
            <label class="row" class="{{book.status}}" *ngIf="book.status == 'canceled'">
              status : annulée
            </label>
          </div>
        </div>
      </div>


    </mat-card-content>
    <mat-card-actions>
      <div class="col-12">
        <div class="row justify-content-center">
          <button class="col-8" (click)='displayLeafletDialog();' mat-stroked-button color="primary"><label>
              Afficher
              <mat-icon aria-hidden="false" aria-label="voir sur la carte">map</mat-icon>
            </label>
          </button>

        </div>
      </div>
    </mat-card-actions>
  </ng-template>
  <div class="row loading-block">
    <ng-template [ngIf]="station == null">
      <mat-progress-bar class="col-12" mode="indeterminate" color='primary'></mat-progress-bar>
    </ng-template>
  </div>
</mat-card> -->